<template>
  <StaffLayout section="Global Link Warnings" showHeader>
    <Loading v-if="isLoading" />
    <div v-else>
    <span
      v-if="linkWarningsCount > 0"
     
      class="text-orange-400 cursor-pointer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6 inline-block"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
        />
      </svg>
      <h1 class="inline-block ml-2 text-lg">
        There are {{ urlWarningsCount }} potentially broken URLs linked
        {{ linkWarningsCount }} times across {{ linkWarningsPortalCount }} portals
      </h1>
    </span>


      <BaseCheckbox
        class="mt-3 ml-3"
        label="Show links with suppressed warnings"
        v-model="showSuppressedLinks"
      />
      <div v-for="url in linksGroupedByUrl" :key="url.linkUrl" class="pt-4">
        <div class="font-bold">
          <a
            :href="url.linkUrl"
            target="_blank"
            class="text-blue-600 dark:text-blue-500 hover:underline"
            >{{ url.linkUrl }}</a
          >
          <button
            v-if="!url.links.every((l) => l.isWarningSuppressed)"
            class="float-right inline-flex justify-center p-2 md:p-1 md:pr-2 text-sm font-medium text-blue-900 bg-blue-50 bg-blue-300 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
            type="button"
            @click="suppressAllLinkWarningsByURL(url.linkUrl)"
          >
            Suppress all warnings for this URL
          </button>
        </div>
        <div class="border my-2">
          <div
            v-for="link in url.links"
            :key="link.linkId"
            class="block mb-2 px-2 cursor-pointer hover:bg-blue-200 flex"
            @click="editLink(link)"
          >
            <div
              class="grow-0"
              :title="
                link.isWarningSuppressed
                  ? 'Detected broken link, warning suppressed'
                  : 'Detected broken link'
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 inline-block mr-2"
                :class="link.isWarningSuppressed ? 'text-slate-400' : 'text-orange-400'"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
            </div>
            <div class="grow">
              <span class="block font-bold">{{ link.portalName }}</span>
              <span class="block ml-2">{{ link.linkSectionSubheading }}</span>
              <span class="block ml-4">{{ link.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditPopup
      entity-name="Link"
      :is-visible="isLinkPopupVisible"
      :is-edit-mode="true"
      :save-error="saveError"
      :delete-enabled="true"
      @close="isLinkPopupVisible = false"
      @save="saveLink"
      @delete="deleteLink"
    >
      <div>
        <div
          v-if="!linkResults.find((lr) => lr.linkId == selectedLink).isKnownGood"
          :title="
            linkResults.find((lr) => lr.linkId == selectedLink).isWarningSuppressed
              ? 'Detected broken link, warning suppressed'
              : 'Detected broken link'
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-5 m-1 inline float-left align-middle"
            :class="
              linkResults.find((lr) => lr.linkId == selectedLink).isWarningSuppressed
                ? 'text-slate-400'
                : 'text-orange-400'
            "
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
          <p
            :class="
              linkResults.find((lr) => lr.linkId == selectedLink).isWarningSuppressed
                ? 'text-slate-400'
                : 'text-orange-400'
            "
          >
            {{
              linkResults.find((lr) => lr.linkId == selectedLink).isWarningSuppressed
                ? "Broken link detected, warning is being suppressed"
                : "Broken link detected, please manually verify link"
            }}
          </p>
        </div>

        <div
          v-if="
            linkResults.find((lr) => lr.linkId == selectedLink).isKnownGood &&
            linkResults.find((lr) => lr.linkId == selectedLink).isWarningSuppressed
          "
          title="Link is not broken, however warnings are suppressed. It is not recommended to suppress known good links."
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-5 m-1 inline float-left align-middle text-slate-400"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
            />
          </svg>
          <p class="text-slate-400">
            Warnings for this link are being suppressed, however link has been verified by
            checker. It is recommended to now disable warning suppression for this link.
          </p>
        </div>
      </div>
      <h2 class="font-bold mt-4" v-if="linkResults">
        {{ linkResults.find((lr) => lr.linkId == selectedLink).portalName }}
      </h2>
      <h3 class="font-semibold" v-if="linkResults">
        {{ linkResults.find((lr) => lr.linkId == selectedLink).linkSectionSubheading }}
      </h3>
      <BaseInput label="Label" v-model="linkLabel" :error="errorsLink.linkLabel" />
      <BaseInput label="Address" v-model="linkUrl" :error="errorsLink.linkUrl" />
      <BaseCheckbox label="Suppress Warning" v-model="isWarningSuppressed" class="mt-2" />
      <div
        class="text-blue-600 dark:text-blue-500 hover:underline cursor-pointer mt-4"
        @click="searchSimilarLinks(linkUrl)"
      >
        Show all other portals that have this link
      </div>
    </EditPopup>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useAdminStore } from "../../store/adminStore";
import { useBldgStore } from "../../store/bldgStore";
import { SaveLink, WarningLinkDTO } from "../../store/generatedFetchClient";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";

const router = useRouter();
const bldgStore = useBldgStore();
const adminStore = useAdminStore();
const isLoading = ref(false);

const showSuppressedLinks = ref(false);


const linkResults = ref([] as WarningLinkDTO[]);
const linksGroupedByUrl = computed(() => {
  var urls = [] as {
    linkUrl: string;
    links: WarningLinkDTO[];
  }[];
  linkResults.value
    .filter((l) => !l.isWarningSuppressed || showSuppressedLinks.value)
    .forEach((link) => {
      var sectionsMap = urls.map((url) => url.linkUrl);
      if (sectionsMap.includes(link.linkUrl)) {
        urls[sectionsMap.indexOf(link.linkUrl)].links.push(link);
      } else {
        urls.push({
          linkUrl: link.linkUrl,
          links: [link],
        });
      }
    });

  return urls;
});

const linksGroupedByPortal = computed(() => {
  var urls = [] as {
    portalId: number;
    links: WarningLinkDTO[];
  }[];
  linkResults.value
    .filter((l) => !l.isWarningSuppressed || showSuppressedLinks.value)
    .forEach((link) => {
      var sectionsMap = urls.map((url) => url.portalId);
      if (sectionsMap.includes(link.portalId)) {
        urls[sectionsMap.indexOf(link.portalId)].links.push(link);
      } else {
        urls.push({
          portalId: link.portalId,
          links: [link],
        });
      }
    });

  return urls;
});

const linkWarningsCount = computed(() => linkResults.value?.length ?? 0);
const urlWarningsCount = computed(() => linksGroupedByUrl.value?.length ?? 0);
const linkWarningsPortalCount = computed(
  () => 
    linksGroupedByPortal.value?.length ?? 
    0
);


onMounted(loadData);
async function loadData() {
  isLoading.value = true;
  console.log("loading data");

  let results = await adminStore.getLinkWarnings();
  if (Array.isArray(results)) {
    linkResults.value = results;
  
    await adminStore.getCounts();

  } else {
    console.log("Failed to get link warnings");
    console.log(results);
  }

  isLoading.value = false;
}

async function suppressAllLinkWarningsByURL(url: string) {
  await adminStore.suppressWarningsByUrl(url);
  await loadData();
  await adminStore.getCounts(true);
}

let selectedLink = ref<number>(0);
let saveError = ref("");

const { handleSubmit: handleSubmitLink, errors: errorsLink } = useForm({
  validationSchema: yup.object({
    linkLabel: yup.string().required().max(50).label("Label"),
    linkUrl: yup.string().required().max(512).label("Address"),
  }),
  initialValues: {
    linkLabel: "",
    linkUrl: "",
  },
});

let isLinkPopupVisible = ref(false);
const { value: linkLabel } = useField<string>("linkLabel");
const { value: linkUrl } = useField<string>("linkUrl");
const { value: isWarningSuppressed } = useField<boolean>("isWarningSuppressed");

function onInvalidSubmit(ctx: any) {
  saveError.value = "One or more invalid form inputs.";
  console.log("error trying to submit form", ctx);
}

let saveLink = handleSubmitLink(onValidSubmitLink, onInvalidSubmit);

async function onValidSubmitLink() {
  console.log("saving Link");
  saveError.value = "";

  var link = {
    linkId: selectedLink.value ?? 0,
    portalId: linkResults.value.find((lr) => lr.linkId == selectedLink.value).portalId,
    linkSectionId: linkResults.value.find((lr) => lr.linkId == selectedLink.value)
      .linkSectionId,
    label: linkLabel.value,
    linkUrl: linkUrl.value,
    isWarningSuppressed: isWarningSuppressed.value,
  } as SaveLink;

  let possibleError = await bldgStore.saveLink(link);
  if (possibleError) {
    saveError.value = possibleError;
    return;
  }
  isLinkPopupVisible.value = false;

  loadData();
  await adminStore.getCounts(true);
}

function editLink(link: WarningLinkDTO) {
  linkLabel.value = link.label ?? "";
  linkUrl.value = link.linkUrl ?? "";
  isWarningSuppressed.value = link.isWarningSuppressed;
  selectedLink.value = link.linkId ?? 0;

  saveError.value = "";
  isLinkPopupVisible.value = true;
}

async function deleteLink() {
  if (selectedLink.value) {
    console.log(`Deleting Link ${selectedLink.value}`);
    saveError.value = await bldgStore.deleteLink(selectedLink.value);
    if (saveError.value) return;
  }
  isLinkPopupVisible.value = false;

  loadData();
  await adminStore.getCounts(true);
}

function searchSimilarLinks(link: string) {
  router.push("/staff/linksearch?search=" + link);
}
</script>
